<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  *{
    box-sizing: border-box;

  }
  .mymatch{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
  }
  .mymatch .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .mymatch .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .mymatch .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .mymatch .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .mymatch .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .mymatch .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .mymatch .nav ul li.on{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .mymatch .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .mymatch .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .mymatch .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .mymatch .content .title img{
    margin-right: 15px;
  }
  .mymatch .content .text1{
    /*background-color: #2a2a2a;*/
    height: 1900px;
  }
  .mymatch .content .text1 ul li{
    width: 1100px;
    margin: 0 auto;
    margin-bottom: 16px;
    border-radius: 4px;
    background-size: cover;
    position: relative;
    transition: 0.3s all;
    background-image: url("https://cdn.player.me/media/cache/gamecover/c1/65/c9/223633f724441c9dee524b603508bb6b.jpg");
    height: 210px;
    background-position: center;
  }
  .mymatch .content .text1 ul li:hover{
    width: 1150px;
    /*height: 220px;*/
  }
  .mymatch .content .text1 ul li:hover .left{
    margin-left: 32px;
    /*margin-top: 32px;*/
  }
  .mymatch .content .text1 ul li a{
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
  }
  .left {
    display: inline-block;
    width: 80px;
    height: 70px;
    border-radius: 2px;
    color: white;
    font-weight: 700;
    text-align: center;
    background-color: #596277;
    float: left;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
  }
  .heading{
    margin: 8px 0;
  }
  .sub{
    top: 32px;
    left: 32px;
    font-size: 26px;
  }
  .right {
    float: left;
    margin-left: 24px;
    margin-top: 32px;
  }
  .name1{
    margin-bottom: 4px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ccc;
  }
  .name2 {
    margin-top: 0;
    margin-bottom: 16px;
    color: #ffffff;
    font-size: 29px;
    font-weight: 900;
  }
  .name3 {
    margin-top: 8px;
    margin-bottom: 0;
    color: #ccc;
  }
  .name4 {
      margin-top: 8px;
      margin-bottom: 0;
      color: #ccc;
  }
  .name5 {
    margin-top: 8px;
    margin-bottom: 0;
    color: #ccc;
  }
</style>
<template>
  <div class="mymatch">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li class="on" @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
        <li @click="urlFun('/stadium')">场馆<span>Venue</span></li>
        <li @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>赛程</div>
      <div class="text1">
        <!--<myhtml v-bind:matchData="gameAgainst"></myhtml>-->
        <!--<myhtml></myhtml>-->
        <ul>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019TOP16">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">In Progress</p>
                <p class="name2">PPL Fighters Masters 2019 Ttop16</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">07:00 PM CST</p>
                <p class="name5">16 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL8">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL8</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">05:00 PM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL7">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL7</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">05:00 PM CST</p>
                <p class="name5">35 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL6">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL6</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">03:00 PM CST</p>
                <p class="name5">35 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL5">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL5</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">03:00 PM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL4">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL4</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">01:00 PM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL3">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL3</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">01:00 PM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL2">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL2</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">11:00 AM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://challonge.com/zh_CN/PPL2019POOL1">
              <div class="left">
                <div class="heading">Sep</div>
                <div class="sub">07</div>
              </div>
              <div class="right">
                <p class="name1">Pending</p>
                <p class="name2">PPL Fighters Masters 2019 POOL1</p>
                <p class="name3">Double Elimination</p>
                <p class="name4">11:00 AM CST</p>
                <p class="name5">36 Participants</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
    import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  import myhtml from "./bracket/index.vue"
  export default {
    name: 'Rules',
    components: {
      myhead,
      mybottom,
      myhtml
    },
    data () {
      return {
        gameAgainst:"",
      }
    },

    computed:{

    },
    mounted(){
//        this.MatchData()
    },
    methods:{
      MatchData(){
        let _this=this;
        let formd=new FormData()
        formd.append("seriesId",30)
        formd.append("matchId",139)
        this.$axios.post("http://admin.matchon.net/client/getMatchAgainstPlan",formd).then((data) => {
          if(data.data.code==200){
            console.log(data.data)
          _this.gameAgainst=data.data.data;
        }
        });
      },
      urlFun(url){
        this.$router.push({path:url})
      },

    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Match.vue